import React from 'react';

import Header from '../partials/Header';
import CommunityEngagementFeatures from '../partials/CommunityEngagementFeatures';
import Cta from '../partials/Cta';
import Footer from '../partials/Footer';

function CommunityEngagement() {
  return (
    <div className="flex flex-col min-h-screen overflow-hidden">

      {/*  Site header */}
      <Header />

      {/*  Page content */}
      <main className="flex-grow">

        {/*  Page sections */}
        <CommunityEngagementFeatures />
        <Cta />

      </main>

      {/*  Site footer */}
      <Footer />

    </div>
  );
}

export default CommunityEngagement;